import type { QuestCompletion } from "@/components/QuestsV2/types";

export const questCompletedInLatestPeriod = (
  validFrom: string,
  refreshPeriodHours: number | null,
  completion?: QuestCompletion,
) => {
  // If no completion, quest hasn't been completed yet
  if (!completion) return false;

  // If no refresh period is set and quest is completed, it's a one-time quest
  if (!refreshPeriodHours) return true;

  const now = new Date();
  const latestCompletionDate = new Date(completion.latest_completion_time);
  const validFromDate = validFrom ? new Date(validFrom) : new Date(0);

  // Calculate the current period start based on validFrom and refreshPeriodHours
  const timeSinceValidFrom = now.getTime() - validFromDate.getTime();
  const periodsSinceValidFrom = Math.floor(
    timeSinceValidFrom / (refreshPeriodHours * 60 * 60 * 1000),
  );
  const currentPeriodStart = new Date(
    validFromDate.getTime() +
      periodsSinceValidFrom * refreshPeriodHours * 60 * 60 * 1000,
  );

  // Check if the latest completion was in the current period
  return latestCompletionDate >= currentPeriodStart;
};
